import React, { FC, useState } from 'react';
import Auth0LockContext from './Auth0LockContext';

type Props = {
  client: Auth0LockPasswordlessStatic;
};

const Auth0LockProvider: FC<Props> = ({ client, children }) => {
  const [isAuth, steIsAuth] = useState(false);
  /**
   * Auth0のイベント登録
   * ログイン後セッションデータをlocalstorageに格納
   */
  client.on('authenticated', (authResult) => {
    // ユーザデータを使う場合
    /*
    client.getUserInfo(authResult.accessToken, (error, profileResult) => {
      if (error) {
        return;
      }
    });
    */
    const expiresAt = JSON.stringify(
      authResult.expiresIn * 1000 + new Date().getTime(),
    );
    localStorage.setItem('access_token', authResult.accessToken);
    localStorage.setItem('id_token', authResult.idToken);
    localStorage.setItem('expires_at', expiresAt);
    steIsAuth(true);
  });

  return (
    <Auth0LockContext.Provider value={{ client, isAuth }}>
      {children}
    </Auth0LockContext.Provider>
  );
};

export default Auth0LockProvider;
